import { createApp, h } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { pinia } from '@/js/lib/store';
import { useMemberStore } from '@/js/lib/store/member';
import { useUserStore } from '@/js/lib/store/user';
import FollowButton from '@/js/components/www.iichi.com/organisms/FollowButton.vue';
import FollowRecommend from '@/js/components/www.iichi.com/organisms/FollowRecommend.vue';
import FollowRecommendIfItemLiked from '@/js/components/www.iichi.com/organisms/FollowRecommendIfItemLiked.vue';

const userStore = useUserStore(pinia);
const memberStore = useMemberStore(pinia);

export const addFollowButton = async () => {
  const followButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('follow-button');

  if (followButtonEls.length === 0) {
    return;
  }

  if (userStore.isAuthenticated) {
    const memberIds = Array.from(followButtonEls, (el) => Number(el.dataset.memberId));
    await memberStore.getFollowedList(uniq(memberIds));
  }
  followButtonEls.forEach((el) => {
    createApp({
      render: () =>
        h(FollowButton, {
          memberId: Number(el.dataset.memberId),
          small: el.dataset.small === 'true',
        }),
    }).mount(el);
  });
};

export const addFollowRecommend = () => {
  const followRecommendEl = document.querySelector('follow-recommend') as HTMLElement;
  createApp({
    render: () =>
      h(FollowRecommend, {
        memberId: Number(followRecommendEl.dataset.memberId),
        bump: followRecommendEl.dataset.bump,
      }),
  }).mount(followRecommendEl);
};

export const addFollowRecommendIfItemLiked = () => {
  const FollowRecommendIfItemLikedEl = document.querySelector('follow-recommend-if-item-liked') as HTMLElement;
  createApp({
    render: () =>
      h(FollowRecommendIfItemLiked, {
        itemId: Number(FollowRecommendIfItemLikedEl.dataset.itemId),
        memberId: Number(FollowRecommendIfItemLikedEl.dataset.memberId),
      }),
  }).mount(FollowRecommendIfItemLikedEl);
};
